export { default } from 'cccisd-game-conversation2';
